import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Icon, Table, Popup } from 'semantic-ui-react';
import FavouriteStar from '../../favourite-star';
import TargetLink from '../../target-link';
import AssetTypeIcon from '../../asset-type-icon';

const VKAsset = ({
  asset,
  favouriteStateHandler,
  uploadSupportingDataComponent,
  supportingDataComponent,
}) => (
  <Table.Row>
    <Table.Cell>
      <Popup
        content={<span>VK { _.capitalize(_.get(asset, 'assetType', 'post')) }</span>}
        trigger={
          <AssetTypeIcon asset={asset} />
        }
      />
    </Table.Cell>
    <Table.Cell textAlign="left">
      <TargetLink renderIf href={_.get(asset, 'assetURL')}>
        { _.get(asset, 'extraData.text', '-') }
      </TargetLink>
    </Table.Cell>
    <Table.Cell><Icon name="circle thin" color="grey" /></Table.Cell>
    <Table.Cell><Icon name="minus" color="grey" /></Table.Cell>
    <Table.Cell>
      <FavouriteStar asset={asset} onClick={favouriteStateHandler} />
    </Table.Cell>
    <Table.Cell>
      {uploadSupportingDataComponent}
    </Table.Cell>
    <Table.Cell>{supportingDataComponent}</Table.Cell>
    <Table.Cell />
  </Table.Row>
);

VKAsset.propTypes = {
  asset: PropTypes.object.isRequired,
  favouriteStateHandler: PropTypes.func.isRequired,
};

export default VKAsset;



/** WEBPACK FOOTER **
 ** ./src/components/asset-table/assets-type/vk.js
 **/